function optionUpdate() {
  let variantIdDiv = document.querySelector('.bold_options_edit_in_cart input[name=id]');
  if (variantIdDiv === null) { return; }
  let variantId = variantIdDiv.value;
  let row = fetchVariant(variantId);
  const selectedVariantName = row.variant_title;
  const filteredName = selectedVariantName.replace(/ ※\d+/g, '');
  showVariantTitle(filteredName);
  handbagDisplay(filteredName, !selectedVariantName.includes("※1"));
  wrapDisplay(filteredName, !selectedVariantName.includes("※2"));
  forceWrap(filteredName, selectedVariantName.includes("※3"));
}

function showVariantTitle(title) {
  let titleDiv = document.querySelector('.bold_lightbox .bold_option_product_info_title');
  let variantDiv = titleDiv.querySelector('div.variant_title');
  if (variantDiv === null) {
    let variantDiv = document.createElement('div');
    variantDiv.classList.add('variant_title');
    variantDiv.textContent = "【"+title+"】";
    titleDiv.append(variantDiv);
  }
}

function fetchVariant(variantId) {
  let items = window.BOLD.common.Shopify.cart.items;
  for (let i = 0; i < items.length; i++) {
    if (parseInt(variantId) === parseInt(items[i].id)) {
      return items[i];
    }
  }
}

const handleMutation = (mutationsList, observer) => {
  let flag = false;
  mutationsList.forEach(mutation => {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach(n=>{
        if (n.classList?.contains('anygift-cart-page-container')) {
          cloneAGButton();
        }
        if (n.nodeName === '#text' || !(n.classList?.contains('bold_help_text_disabled') || n.classList?.contains('bold_help_text_hide_nowrap') || n.classList?.contains('bold_option_product_info_title'))) {
          flag = true;
        }
      });
      mutation.removedNodes.forEach(n=>{
        if (n?.classList?.contains('cart-items')) {
          checkoutValidation();
        }
      })
    }
  });
  if (flag) {
    optionUpdate();
  }
};

let body = document.querySelector('body');
  
const observer = new MutationObserver(handleMutation);

const config = { attributes: false, childList: true, subtree: true };

observer.observe(body, config);